import { loadCompanyCensusEnv } from "@/env";
import { createApiClient } from "@cakewalk/frontend-api";

/**
 * Pre-session client for the company-census "add phone" step.
 *
 * A user who already has a login (email + password) but no MFA set up hits this
 * on first sign-in: they've cleared the password step, but the pool can't send
 * an SMS code without a `phone_number`. This PUBLIC platform-API endpoint sets
 * the number (unverified) so the login step can drive the SMS challenge inline.
 * Mirrors the wallet/cockpit `/auth/add-phone` flow.
 */

function baseUrl(): string {
  return loadCompanyCensusEnv().VITE_API_BASE_URL.replace(/\/$/, "");
}

export interface AddCensusPhoneResult {
  success: boolean;
}

/** Set the Cognito phone number for a login with no MFA yet. */
export function addCensusPhone(email: string, phone: string): Promise<AddCensusPhoneResult> {
  return createApiClient({ baseUrl: baseUrl(), requireAuth: false }).post<AddCensusPhoneResult>(
    "/api/quote-census/auth/add-phone",
    { email: email.trim(), phone: phone.trim() },
  );
}
